export default __webpack_public_path__ + "static/media/Header1.f6c20e19.png";